import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-video",
  "use": "icon-video-usage",
  "viewBox": "0 0 17.99 11.95",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17.99 11.95\" id=\"icon-video\"><defs></defs><title>资源 2</title><g id=\"icon-video_图层_2\" data-name=\"图层 2\"><g id=\"icon-video_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M17.34,1.16,14,2V.51A.51.51,0,0,0,13.47,0H.51A.51.51,0,0,0,0,.51V11.44A.51.51,0,0,0,.51,12h13a.51.51,0,0,0,.51-.51V10l3.36.83a.53.53,0,0,0,.65-.51V1.67A.53.53,0,0,0,17.34,1.16ZM10.13,6.27,5.53,8.93A.35.35,0,0,1,5,8.63V3.32A.35.35,0,0,1,5.53,3l4.6,2.66A.34.34,0,0,1,10.13,6.27Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/svg/video.svg
// module id = 9AUi
// module chunks = 41